export default __webpack_public_path__ + "/assets/b.jpg";